import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Box,
  Button,
  CardHeader,
  Hidden,
  IconButton,
  Typography
} from "@material-ui/core";
import LoginForm from "./LoginForm";
import InputSearch from "./InputSearch";
import CGU from "./CGU";
import DetailsRDV from "./rdv/DetailsRDV";
import { connect } from "react-redux";
import { getCGU, getCanceledReason } from "../../utils/fetcher";
import { setReturnedValue } from "../../actions";
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined
} from "@material-ui/icons";

class Home extends Component {
  state = {
    openModal: false,
    showRDVButton: false,
    openModalStart: true,
    currentIndex: 0
  };

  componentDidMount() {
    this.props.fetchCGU();
    this.props.fetchCancelReason();
  }

  handleShowRdvButton = () => {
    this.setState({ showRDVButton: true });
  };

  handlePrevClick = () => {
    this.setState(prevState => ({
      currentIndex: prevState.currentIndex > 0 ? prevState.currentIndex - 1 : 0,
      showRDVButton: false
    }));
  };

  handleNextClick = () => {
    this.setState(prevState => ({
      currentIndex:
        prevState.currentIndex < this.props.ressourceRdv?.data.length - 1
          ? prevState.currentIndex + 1
          : prevState.currentIndex,
      showRDVButton: false
    }));
  };

  handleSelectIndex = index => {
    this.setState({
      currentIndex: index
    });
  };

  render() {
    const { show } = this.props;
    const { currentIndex } = this.state;
    return (
      <>
        <div
          style={{
            maxWidth: 640,
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: 8,
            paddingRight: 22
          }}
        >
          {this.props.isOpenSearch && (
            <Hidden mdUp>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginTop: "6px",
                  marginBottom: "6px"
                }}
              >
                <InputSearch
                  resourceRdv={this.props?.ressourceRdv?.data}
                  onChange={this.handleSelectIndex}
                />
              </div>
            </Hidden>
          )}
          {show !== "login" && (
            <>
              <Hidden mdUp>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    marginTop: "6px",
                    marginBottom: "6px",
                    textAlign: "center"
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: 0,
                      margin: 0
                    }}
                  >
                    <IconButton onClick={this.handlePrevClick}>
                      <ArrowBackIosOutlined />
                    </IconButton>
                    <Typography
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "18px",
                        fontWeight: 600
                      }}
                    >
                      Rendez-vous{" "}
                      {this.props.ressourceRdv?.data.length > 0
                        ? currentIndex + 1
                        : currentIndex}
                      /{this.props.ressourceRdv?.data.length || 0}
                    </Typography>
                    <IconButton onClick={this.handleNextClick}>
                      <ArrowForwardIosOutlined />
                    </IconButton>
                  </Box>
                </div>
              </Hidden>
              <Hidden smDown>
                <CardHeader
                  subheader={
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: 0,
                        margin: 0
                      }}
                    >
                      <IconButton onClick={this.handlePrevClick}>
                        <ArrowBackIosOutlined />
                      </IconButton>
                      <Typography
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "16px",
                          fontWeight: 600
                        }}
                      >
                        Rendez-vous{" "}
                        {this.props.ressourceRdv?.data.length > 0
                          ? currentIndex + 1
                          : currentIndex}
                        /{this.props.ressourceRdv?.data.length || 0}
                      </Typography>
                      <IconButton onClick={this.handleNextClick}>
                        <ArrowForwardIosOutlined />
                      </IconButton>
                    </Box>
                  }
                  action={
                    <InputSearch
                      resourceRdv={this.props?.ressourceRdv?.data}
                      onChange={this.handleSelectIndex}
                    />
                  }
                  style={{
                    display: "flex",
                    height: "1rem",
                    padding: "1rem 0 1rem 0"
                  }}
                />
              </Hidden>
            </>
          )}
        </div>
        <div
          style={{
            maxWidth: 650,
            marginLeft: "auto",
            marginRight: "auto",
            maxHeight: "calc(100vh - 165px)",
            overflow: "hidden",
            overflowY: "scroll"
          }}
        >
          {show === "login" && <LoginForm />}

          {show === "rdv" && (
            <>
              <div
                className="App"
                style={{
                  margin: 10,
                  borderRadius: "8px"
                }}
              >
                <Box
                  sx={{
                    borderRadius: "8px",
                    bgcolor: "white",
                    height: "100%",
                    color: "white"
                  }}
                >
                  {this.props.ressourceRdv ? (
                    <DetailsRDV
                      handleShowRdvButton={this.handleShowRdvButton}
                      key={currentIndex}
                      selectedRdv={currentIndex}
                      rdv={this.props.ressourceRdv?.data[currentIndex]}
                    />
                  ) : null}
                </Box>
              </div>
              {this.state.showRDVButton && (
                <div
                  className="App"
                  style={{
                    margin: 10,
                    borderRadius: "8px"
                  }}
                >
                  <Button
                    onClick={() => {
                      const urlSearchParams = new URLSearchParams(
                        window.location.search
                      );
                      urlSearchParams.append("action", "newrdv");
                      urlSearchParams.delete("page");
                      urlSearchParams.delete("tokensms");
                      urlSearchParams.delete("identification_rdv");
                      const newUrl = `${
                        window.location.pathname
                      }?${urlSearchParams.toString()}`;
                      window.location.replace(newUrl);
                    }}
                    type="submit"
                    fullWidth
                    variant="outlined"
                    style={{
                      backgroundColor: "#009EFF",
                      border: "#009EFF",
                      color: "white",
                      borderRadius: "50px",
                      height: "40px",
                      textTransform: "none",
                      fontSize: "16px",
                      width: "100%"
                    }}
                  >
                    {`+ Prendre un RDV`}
                  </Button>
                </div>
              )}

              {!this.state.showRDVButton && (
                <div>
                  <CGU
                    cguData={
                      (this.props.dataSource &&
                        this.props?.dataSource["cguStr"]) ||
                      ""
                    }
                    consignesData={
                      (this.props.ressourceRdv?.data &&
                        this.props.ressourceRdv?.data[0]?.consigne) ||
                      []
                    }
                  />
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

Home.propTypes = {
  isOpenSearch: PropTypes.bool,
  goToBegining: PropTypes.func,
  dataSource: PropTypes.any,
  show: PropTypes.any.isRequired,
  ressourceRdv: PropTypes.object,
  fetchCGU: PropTypes.func,
  fetchCancelReason: PropTypes.any,
  setReturnedValue: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    typeConsultation: state.returnedValue.typeConsultation,
    isFromAdmin: state.returnedValue.from,
    messageWithCode: state.messageWithCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    fetchCGU: () => dispatch(getCGU()),
    fetchCancelReason: () => dispatch(getCanceledReason())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
